import wire from '../wire';

export default wire(
  'sources',
  ``,
  () => {
    // Migrated to dashboard_vue
    window.location.href = '/sources';
  },
  'SourcesController'
);



// WEBPACK FOOTER //
// ./app/pages/sources/_index.js